import { render, staticRenderFns } from "./SalaryTaxMonth.vue?vue&type=template&id=12205eb0&scoped=true"
import script from "./SalaryTaxMonth.vue?vue&type=script&lang=js"
export * from "./SalaryTaxMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12205eb0",
  null
  
)

export default component.exports